module.exports = "https://static.wmbcdn.com/uniweb/images/49278b82b04ed1af022395e1c875ec8d.svg";